<div
    *ngIf="isNullPanel"
    class="panel panel-empty relative"
    (click)="handleAddPanelClicked()"
>
    <span
        data-cy="dashboard-add-element-button"
        class="subtitle light"
        style="cursor: pointer"
    >
        <mat-icon
            data-cy="dashboard-add-element-icon"
            svgIcon="blue-add"
            style="vertical-align: middle"
        ></mat-icon>
        {{ "dashboard.panel.labels.add" | translate }}
    </span>

    <div
        (click)="handleCloseErrorMessageClicked($event)"
        class="error-notification-container"
        *ngIf="isResourceNotFound"
    >
        <div class="error-notification">
            <app-validation-error-label
                data-cy="deleted-element-notification"
                [message]="
                    'dashboard.panel.errors.resource-not-found' | translate
                "
            ></app-validation-error-label>
            <div>
                <mat-icon
                    data-cy="deleted-element-notification-x-icon"
                    svgIcon="cancel-close"
                ></mat-icon>
            </div>
        </div>
    </div>
</div>

<div [hidden]="isNullPanel" style="width: 100%; height: 100%">
    <div #container class="panel panel-content"></div>
</div>
